import { useQuery } from 'hooks/useCustomQuery';
import getAllTrunks from 'API/Trunk/getAllTrunks';
import ScopeType from 'utils/enums/ScopeType';

/**
 * (3133/3153) The company's trunks, for the account summary's Trunks tile and
 * the degraded trunks notification. Requested at company scope, like the rest
 * of the dashboard (3159).
 */
const useGetCompanyTrunks = (companyId, options = {}) =>
    useQuery({
        queryKey: ['dashboardHome', 'trunks', companyId],
        queryFn: () => getAllTrunks(companyId, ScopeType.COMPANY),
        enabled: !!companyId,
        refetchOnWindowFocus: false,
        retry: false,
        ...options,
    });

export default useGetCompanyTrunks;
